import SharedAsset from '@zenbusiness/zui/SharedAsset';
import { superstyled } from '@zenbusiness/zui/styles';

export const IllustrationAsset = superstyled({
  tag: SharedAsset,
  name: 'PersonalizedModal',
  slot: 'IllustrationAsset',
  styles: {
    width: '10rem',
    maxHeight: '10rem',
    margin: 'auto',
  },
});
